module.exports = __webpack_public_path__ + "img/deployment-status.941e4b7e.png";